"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductLabelDomainType = void 0;
let ProductLabelDomainType = exports.ProductLabelDomainType = /*#__PURE__*/function (ProductLabelDomainType) {
  /** Only Offer, New, SuperDeal */
  ProductLabelDomainType["Deal"] = "Deal";
  /** All of the ProductLabelType except Offer, New, SuperDeal, AddToBasketVisible */
  ProductLabelDomainType["Ppa"] = "PPA";
  /** Domain Type for AddToBasketVisible ProductLabelType */
  ProductLabelDomainType["Shopping"] = "Shopping";
  return ProductLabelDomainType;
}({});